import * as is from 'Misc/is';
import { lastItem } from 'Misc/collections';

const MAX_DEPTH = 4;

export default class Change {
  constructor(property, oldVal, newVal, state) {
    this.property = property;
    this.oldVal = oldVal;
    this.newVal = newVal;
    this.state = state;
  }
}

export const generateChangeLedger = (newState, oldState, depth = 0) => {
  if(depth >= MAX_DEPTH) {
    return false;
  }

  const allKeys = Object.keys(Object.assign({}, oldState, newState));
  
  const changes = allKeys
      .reduce((ledger, key) => {
        if(is.def(newState[key]) && !is.def(oldState[key])) {
          ledger[key] = true;
          return ledger;
        }

        // Ugly manual exception for Google IMA's Video "Proxy" element
        if(key !== 'videoSlot' && key !== 'slot') {
          if( (is.str(oldState[key]) || is.num(oldState[key]) || is.bool(oldState[key]) ) && oldState[key] !== newState[key]) {
            ledger[key] = true;
          } else if(is.arr(oldState[key]) && oldState[key].length !== newState[key].length) {
            ledger[key] = true;
          } else if(is.arr(oldState[key]) && (oldState[key].length > 0 || newState[key].length > 0) && oldState[key].length === newState[key].length && lastItem(oldState[key]) !== lastItem(newState[key]) ) {
            ledger[key] = true;
          } else if(is.obj(oldState[key])) {
            ledger[key] = generateChangeLedger(newState[key], oldState[key], depth + 1);
          } else {
            ledger[key] = false;
          }
        } else {
          ledger[key] = false;
        }

        return ledger;
      }, {})

  return Object.keys(changes).length ? changes : false;
};


// WEBPACK FOOTER //
// ./src/Services/State/Change.js